var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "xui-footer",
    { staticClass: "footer-wrap" },
    [
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            showcenter: true,
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "20%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _vm.dialogVisible && !_vm.show1046 && !_vm.show1047
            ? _c("div", [
                _c(
                  "h2",
                  {
                    style:
                      {
                        "font-size": _vm.$store.state.isMobile
                          ? "24px"
                          : "16.5px"
                      } + ";text-align: center;"
                  },
                  [_vm._v("隐私通知")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-wrap",
                    style: {
                      "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
                    }
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            荣耀安全应急响应中心需联网，需收集您的身份信息、交易信息，我们仅在使用具体业务功能时才触发上述行为收集使用相关的个人信息。\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n           本服务为您提供账号登录、漏洞提交、漏洞奖金支付等业务功能，点击“同意”，即表示您同意\n            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-user-protocol",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.safetyURL)
                            }
                          }
                        },
                        [_vm._v("荣耀安全应急响应中心用户协议")]
                      ),
                      _vm._v(" 、\n            "),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-secret-statement",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.privacyURL)
                            }
                          }
                        },
                        [_vm._v("关于荣耀安全应急响应中心与隐私的声明")]
                      ),
                      _vm._v("。\n          ")
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogVisible && _vm.show1046 && !_vm.show1047
            ? _c("div", [
                _c(
                  "h2",
                  {
                    style:
                      {
                        "font-size": _vm.$store.state.isMobile
                          ? "24px"
                          : "16.5px"
                      } + ";text-align: center;"
                  },
                  [_vm._v("变更通知")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-wrap",
                    style: {
                      "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
                    }
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            为提供更好的服务，我们更新了用户协议，请您仔细阅读变更详情，并充分理解相关条款。\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n            用户协议调整如下：\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.content1046) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            详细内容请参阅最新的\n            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-user-protocol",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.safetyURL)
                            }
                          }
                        },
                        [_vm._v("荣耀安全应急响应中心用户协议")]
                      ),
                      _vm._v(
                        " 。 \n            点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。\n          "
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogVisible && _vm.show1047 && !_vm.show1046
            ? _c("div", [
                _c(
                  "h2",
                  {
                    style:
                      {
                        "font-size": _vm.$store.state.isMobile
                          ? "24px"
                          : "16.5px"
                      } + ";text-align: center;"
                  },
                  [_vm._v("变更通知")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-wrap",
                    style: {
                      "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
                    }
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            为提供更好的服务，我们更新了隐私声明，请您仔细阅读变更详情，并充分理解相关条款。\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n            隐私声明调整如下：\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.content1047) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            详细内容请参阅最新的\n            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-secret-statement",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.privacyURL)
                            }
                          }
                        },
                        [_vm._v("关于荣耀安全应急响应中心与隐私的声明")]
                      ),
                      _vm._v(
                        "。 \n            点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。\n          "
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogVisible && _vm.show1047 && _vm.show1046
            ? _c("div", [
                _c(
                  "h2",
                  {
                    style:
                      {
                        "font-size": _vm.$store.state.isMobile
                          ? "24px"
                          : "16.5px"
                      } + ";text-align: center;"
                  },
                  [_vm._v("变更通知")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-wrap",
                    style: {
                      "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
                    }
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            为提供更好的服务，我们更新了用户协议和隐私声明，请您仔细阅读变更详情，并充分理解相关条款。\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n            用户协议调整如下：\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.content1046) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n            隐私声明调整如下：\n          ")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.content1047) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            详细内容请参阅最新的\n            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-user-protocol",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.safetyURL)
                            }
                          }
                        },
                        [_vm._v("荣耀安全应急响应中心用户协议")]
                      ),
                      _vm._v(" 、\n            "),
                      _c(
                        "span",
                        {
                          staticClass: "honor-security-secret-statement",
                          on: {
                            click: function($event) {
                              return _vm.handleLink(_vm.privacyURL)
                            }
                          }
                        },
                        [_vm._v("关于荣耀安全应急响应中心与隐私的声明")]
                      ),
                      _vm._v(
                        "。 \n            点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。\n          "
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", center: "" },
              slot: "footer"
            },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-con" }, [
        _c(
          "div",
          { staticClass: "footer-links" },
          [
            _c(
              "a",
              {
                staticClass: "footer-link",
                attrs: { href: _vm.safetyURL, target: "_blank" }
              },
              [_vm._v("用户协议")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "footer-link",
                attrs: { to: "/report", exact: "" }
              },
              [_vm._v("提交漏洞")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "footer-link",
                attrs: { href: _vm.privacyURL, target: "_blank" }
              },
              [_vm._v("隐私声明")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "footer-link",
                attrs: { href: "mailto:security@honor.com", target: "_blank" }
              },
              [_vm._v("联系我们")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "footer-link",
                attrs: { href: _vm.cookieUrl, target: "_blank" }
              },
              [_vm._v("Cookie")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "copyright" }, [
          _c("span", { staticClass: "copyright-txt" }, [
            _vm._v(
              "版权所有 © 荣耀终端股份有限公司 2020-" +
                _vm._s(_vm.nowYear) +
                " 保留一切权利。"
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "copyright-txt copyright-link",
              attrs: {
                href:
                  "https://beian.mps.gov.cn/#/query/webSearch?code=44030002002883",
                rel: "noreferrer",
                target: "_blank"
              }
            },
            [
              _c("img", { attrs: { src: require("../images/ghs.png") } }),
              _vm._v("粤公网安备 44030002002883")
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "copyright-txt",
              staticStyle: { "padding-left": "10px" },
              attrs: {
                target: "_blank",
                href: "http://beian.miit.gov.cn/",
                rel: "nofollow"
              }
            },
            [_c("span", [_vm._v("粤ICP备20047157号")])]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 